import React from "react";
import { Form, FormControl } from "react-bootstrap";
import { formatCount } from "../pages/redesign/viewLayout/sidePanel/Suggestion";

export const Checkboxes = ({ name, formData, className }) => {
  const { values, onChange, options, type } = formData[name];
  return options
    .map(keyToValue)
    .map(addLabels)
    .map((option, index) => (
      <Form.Check
        key={index}
        id={name + index}
        value={option.value}
        type={type}
        label={
          <span>
            {option.label} <small>{formatCount(option.doc_count)}</small>
          </span>
        }
        className={(values.includes(option.value) && "text-primary ") + className}
        checked={values.includes(option.value)}
        onChange={onChange}
      />
    ));
};

export const Dropdown = ({ name, formData }) => {
  const { values, onChange, disabled, options } = formData[name];
  return (
    <FormControl as="select" size="sm" value={values[0]} onChange={onChange} disabled={disabled}>
      {options.map(addLabels).map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </FormControl>
  );
};

export const addLabels = (option) => (typeof option === "string" ? { value: option, label: option } : option);
export const keyToValue = (option) =>
  typeof option.key === "string" ? { value: option.key, label: option.key, ...option } : option;
